<template>
  <div>
    <zj-layout-container v-loading="loading" element-loading-text="加载中...">
      <zj-layout-header>
        <div class="listtitle">{{ title }}</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="联系电话" prop="Phone">
            <el-input v-model="Phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="渠道">
            <el-select v-model="SourceDesc" placeholder="请选择渠道">
              <el-option
                v-for="item in EmergencyChannel"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.Description"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="求助地点" prop="Location">
            <el-input
              v-model="Location"
              placeholder="请输入求助地点"
            ></el-input>
          </el-form-item>
          <el-form-item label="处理状态" v-if="type == 'all'">
            <el-select v-model="ProcessStatus" placeholder="请选择处理状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="待处理" value="0"></el-option>
              <el-option label="待结案" value="1"></el-option>
              <el-option label="已完结" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报警日期" prop="date" v-if="type == 'all'">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <!-- <el-button size="mini" @click="onAdd">添 加</el-button> -->
          <!-- <el-button size="mini" @click="onbatchDel">删 除</el-button> -->
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Location"
                label="求助地点"
              ></el-table-column>
              <el-table-column
                prop="BeginDate"
                label="报警时间"
                :formatter="formatDate"
                width="200"
              ></el-table-column>
              <el-table-column
                prop="SourceDesc"
                label="渠道"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="Contact"
                label="求助人"
                width="160"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="联系电话"
              ></el-table-column>
              <el-table-column prop="ProcessStatus" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.ProcessStatus == '0'">待处理</span>
                  <span v-else-if="scope.row.ProcessStatus == '1'">待结案</span>
                  <span v-else-if="scope.row.ProcessStatus == '2'">已完结</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="ProcessStatus"
                fixed="right"
                label="操作"
                width="160"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.ProcessStatus == '0'"
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >处理</el-button
                  >
                  <el-button
                    v-if="scope.row.ProcessStatus == '1'"
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >结案</el-button
                  >
                  <el-button
                    v-if="scope.row.ProcessStatus == '2'"
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<style lang="stylus"></style>
<script>
import MyApis from "../../../apis";
export default {
  name: "WaitingForHelpList",
  controller: "UI",
  action: "WaitingForHelpList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      selectData: null,
      AlertType: "13", //预警类型
      AlertTypeArr: [],
      AlerteLevel: null, //预警级别
      AlerteLevelArr: [],
      Phone: "", //求助人电话
      Location: "", //求助地点
      SourceDesc: "", //求助渠道
      ProcessStatus: "1", //处理状态 0待处理 1待结案 2已结案
      BeginTime: "",
      EndTime: "",
      EmergencyChannel: [],
      type: "",
      date: "",
      title: "待结案求助",
      loading:false
    };
  },
  watch: {
    
    // 监听查询变化
    $route(){
      this.type = this.$route.query.type;
    },
    // 监听身份变化
    type(newV) {
      this.type = newV;
      console.log("type", newV);
      this.init(newV);
    },
  },
  created: function () {
    this.EmergencyCallChannel();
  },
  mounted: function () {
    this.type = this.$route.query.type;
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    EmergencyCallChannel() {
      //预警来源
      this.config
        .getUValue("EmergencyCall:HelpChannel", "")
        .then((d) => {
          console.log("求助报警的预警来源");
          console.log(d);
          this.EmergencyChannel = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    init(type) {
      if (type === "all") {
        this.type = this.$route.query.type;
        this.ProcessStatus = "";
        this.title = "全部求助查询";
        this.logInfo.ActionName = "全部求助查询";
        this.logInfo.PageName = "全部求助列表";
        this.logInfo.LogMessage = "全部求助查询";
      } else {
        this.ProcessStatus = "1";
        this.title = "待结案求助";
        this.logInfo.ActionName = "待结案求助查询";
        this.logInfo.PageName = "待结案求助列表";
        this.logInfo.LogMessage = "待结案求助查询";
      }

      this.clearsearch();
      this.search();
      this.addOperationLog();
    },
    search() {
      // console.log(this.date)
      this.loading = true;
      let data = this.date;
      if (data.length > 0) {
        this.BeginTime = data[0];
        this.EndTime = data[1];
      }
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        ProcessStatus: this.ProcessStatus,
        AlertType: this.AlertType,
        Phone: this.Phone,
        Location: this.Location,
        SourceDesc: this.SourceDesc, //报警渠道
        BeginTime: this.BeginTime, //报警开始时间
        EndTime: this.EndTime, //报警结束时间
      };
      new MyApis.SeekHelpApi()
        .GetAlertItemPagingList(searchInfo)
        .then((r) => {
          this.loading = false;
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
           this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.Phone = "";
      this.Location = "";
      this.SourceDesc = ""; //求助渠道
    },
    //基础数据绑定
    basedatabind() {
      //所属应急组织类型
      this.config
        .getUValue("EmergencyService:TranresourcesType:", "")
        .then((d) => {
          this.options = d.JValue;
          for (var i = 0; i < this.options.length; i++) {
            var item = this.options[i];
            this.TranresourcesTypeDic[item.ItemKey] = item.Extend1;
          }
        })
        .catch((e) => console.error(e));
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //查看详细
    handleClick(index, row) {
      // console.log(index, row);
      let type = "";
      if (row.ProcessStatus == "2") {
        type = "finish";
      } else {
        type = "edit";
      }
      this.$router.push({
        path: "/plugin/seekHelp/UI/WaitingForHelpInfo",
        query: {
          Id: row.Id,
          type: type,
          ProcessStatus: row.ProcessStatus,
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/seekHelp/UI/SeekHelpAlarmInfo",
        query: {
          type: "add",
        },
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
